module.exports = __webpack_public_path__ + "img/sonos.49c2cf3e.jpg";